// @flow
import $ from 'jquery';
import HttpJob from './HttpJob';
import t from '../i18n/I18n';
const debug = require('../debug/debug')('wc:protocol:PollJob');

const defaultConfig = {
  interval: 1000,
  maxTries: 20,
  __counter: 1
};

const defaultPredicate = (data: Object = {}) => {
  const status = (data.status || '').toUpperCase();

  switch (status) {
    case 'DONE':
      return true;
    case 'FAILED':
    case 'CANCELLED':
      let msg = data.message || 'Failed';
      if (msg.indexOf('com.zoom.') > -1) {
        debug('[defaultPredicate()] server error message: ', msg);
        msg = t('SOMETHING_WENT_WRONG_MSG');
      }

      throw new Error(msg);
    default:
      return false;
  }
};

export default class PollJob extends HttpJob {
  _url: string;
  _predicate: Function;
  _config: Object;

  constructor(url: string, predicate: ?Function = defaultPredicate, config: Object = { ...defaultConfig }) {
    super();

    this._url = url;
    this._predicate = predicate;
    this._config = config;

    this._promise = new Promise(async (resolve, reject) => {
      try {
        await this._poll();
        debug('job success');
        this._done = true;
        resolve();
      } catch (err) {
        debug('job error: ', err);
        this._done = true;
        reject(err);
      }
    });
  }

  get description() {
    const desc = super.description;
    return {
      label: `Checking Server Task (${desc.status})`,
      tooltip: `URL: ${this._url}`,
      status: desc.status
    };
  }

  _poll(): Promise<any> {
    const url = this._url;
    const config = this._config;
    const predicate = this._predicate;
    const { interval, maxTries, __counter } = config;
    debug('[poll()] args: ', { config: JSON.stringify(config), url });

    if (this._canceled) {
      debug('[poll()] canceled. return.');
      return Promise.reject(new Error('Canceled'));
    }

    return new Promise((resolve, reject) => {
      if (__counter > maxTries) {
        debug('[poll()] reached maxTries. reject.');
        return reject(new Error('Timeout'));
      }

      const xhr = (this._xhr = $.get(url));

      xhr
        .then((data) => {
          if (predicate(data)) {
            debug('[poll()] passed predicate. resolve.');
            return resolve();
          }

          const nextConfig = { interval: Math.round(interval * 1.25), maxTries, __counter: __counter + 1 };
          this._config = nextConfig;

          setTimeout(() => {
            this._poll()
              .then(resolve)
              .catch(reject);
          }, interval);
        })
        .catch((err) => {
          debug('[poll()] error: ', err);
          reject(err);
        });
    });
  }
}
